// PreventiApp · Sprint 4 · Gate 4.3 — Cliente API del Dashboard.
// Envuelve fetch con el token JWT del AuthContext y devuelve JSON o lanza error.

import { supabase } from './supabase';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

async function getToken() {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.access_token || null;
}

async function apiFetch(path, { method = 'GET', body, params } = {}) {
  const token = await getToken();
  const qs = params
    ? '?' + new URLSearchParams(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')).toString()
    : '';
  const url = `${BACKEND}${path}${qs}`;
  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let payload;
  try { payload = text ? JSON.parse(text) : null; } catch { payload = text; }
  if (!res.ok) {
    const message = payload?.detail || payload?.message || `Error ${res.status}`;
    const err = new Error(message);
    err.status = res.status;
    err.payload = payload;
    throw err;
  }
  return payload;
}

// -------------------- Dashboard --------------------
export const dashboardApi = {
  kpis:                    (colegio_id) => apiFetch('/api/dashboard/kpis', { params: { colegio_id } }),
  induccionKpis:           (colegio_id) => apiFetch('/api/dashboard/induccion/kpis', { params: { colegio_id } }),
  induccionEvolucion:      (colegio_id) => apiFetch('/api/dashboard/induccion/evolucion', { params: { colegio_id } }),
  distribucionDimensiones: (colegio_id, dias = 30) => apiFetch('/api/dashboard/distribucion-dimensiones', { params: { colegio_id, dias } }),
  cursosFoco:              (colegio_id, limit = 10) => apiFetch('/api/dashboard/cursos-foco', { params: { colegio_id, limit } }),
  casosAbiertos:           (colegio_id) => apiFetch('/api/dashboard/casos-abiertos', { params: { colegio_id } }),
  eventosCentinela:        (colegio_id) => apiFetch('/api/dashboard/eventos-centinela', { params: { colegio_id } }),
  casosVencidos:           (colegio_id) => apiFetch('/api/dashboard/casos-vencidos', { params: { colegio_id } }),
  accionHoy:               (colegio_id) => apiFetch('/api/dashboard/accion-hoy', { params: { colegio_id } }),
};

// -------------------- Casos --------------------
export const casosApi = {
  list:       (params) => apiFetch('/api/casos', { params }),
  detail:     (id) => apiFetch(`/api/casos/${id}`),
  historial:  (id) => apiFetch(`/api/casos/${id}/historial`),
  asignables: (colegio_id) => apiFetch('/api/casos/asignables', { params: { colegio_id } }),
  asignar:    (id, body) => apiFetch(`/api/casos/${id}/asignar`, { method: 'POST', body }),
  estado:     (id, body) => apiFetch(`/api/casos/${id}/estado`, { method: 'POST', body }),
  seguimiento:(id, body) => apiFetch(`/api/casos/${id}/seguimiento`, { method: 'POST', body }),
  cerrar:     (id, body) => apiFetch(`/api/casos/${id}/cerrar`, { method: 'POST', body }),
  evidencia:  (evId) => apiFetch(`/api/casos/evidencia/${evId}`),  // Sprint 5 · Paso 3
};
